import { Dayjs } from "dayjs";
import { ICompanyId } from "@endpoints/types/candidate.type";

export interface CandidateDetails {
    tempFullName: string;
    fullName: string;
    profilePic: string | null;
    refNo: string | null;
    candidateId: string;
    email: string;
}

export interface JobDetails {
    tempJobTitle: string;
    title: string;
    refNo: string;
    jobId: string;
    jobRequirementId?: string;
    recruiterAgency?: ICompanyId;
}

export interface SpecificDateTime {
    date: Dayjs;
    startTime: Dayjs;
    endTime: Dayjs;
}

export interface TimeSlot {
    startTime: Dayjs;
    endTime: Dayjs;
}

export interface DaySlot {
    date: Dayjs;
    timeSlots: TimeSlot[];
}

export interface GeneralAvailabilitySlot {
    day: string;
    date: Dayjs;
    startTime: Dayjs;
    endTime: Dayjs;
}

export interface TimeSlotRange {
    startTime: string,
    endTime: string
}

export enum durationType {
    minute,
    hour
}

export interface MeetingDuration {
    label: string,
    type: durationType,
    duration: number,
}

export enum MeetingModeEnum {
    "Virtual Meeting",
    "Face-to-Face",
    "Telephone Call",
}

export enum SlotSelectionTypeEnum {
    'general',
    'specific'
}


export interface CreateEventFormValues {
    candidateDetails: CandidateDetails;
    jobDetails: JobDetails;
    meetingTitle: string;
    meetingDuration: MeetingDuration;
    meetingMode: string;
    specificDateTime: SpecificDateTime;
    meetingDateTimes: DaySlot[],
    url: string;
    address: string;
    generalTime: Record<string, DaySlot[]>;
    availabilitySlots: Record<string, TimeSlotRange[]>
    meetingDescription: string;
}



export interface MeetingGeneralInfoFormValues {
    candidateDetails: CandidateDetails;
    jobDetails: JobDetails;
    meetingTitle: string;
    meetingMode: MeetingModeEnum;
    url: string;
    address: string;
    meetingDescription: string;
}

export interface MeetingAvailabilityFormValues {
    meetingDuration: MeetingDuration;
    availabilitySlots: Record<string, TimeSlotRange[]>
}

export interface ReviewFormData extends Partial<MeetingGeneralInfoFormValues>, Partial<MeetingAvailabilityFormValues> {
    slotSelectionType?: SlotSelectionTypeEnum
}
